export const environment = {
  production: true,
  API_STARTPOINT :"http://my.itariumtech.com:9090/api/",
  // API_VERSION : "1"
};
